module.exports = __webpack_public_path__ + "static/media/experience.d40cfeb2.jpg";